import json from './sprite.js';

export default {
    handle: 'SP_SPS3-NewFriends',
    label: 'es_SPS3-NewFriends_234684082',
    json,
};
